import { Template } from './StagingTypes';

const nonTNMColumns = [
  {
    id: 'id',
    label: 'ID',
    isVisible: false,
    accessor: 'id',
    readOnly: true
  },
  {
    id: 'timing',
    label: 'Timing',
    isVisible: true,
    accessor: 'timing',
    readOnly: true
  },
  {
    id: 'grade',
    label: 'Grade',
    isVisible: true,
    accessor: 'grade',
    readOnly: false
  },
  {
    id: 'stageGroup',
    label: 'Stage Group',
    isVisible: true,
    accessor: 'stageGroup',
    readOnly: false
  }
];

export const defaultTemplate = {
  name: 'default',
  columns: [
    {
      id: 'id',
      label: 'ID',
      isVisible: false,
      accessor: 'id',
      readOnly: true
    },
    {
      id: 'timing',
      label: 'Timing',
      isVisible: true,
      accessor: 'timing',
      readOnly: true
    },
    {
      id: 't',
      label: 'T',
      isVisible: true,
      accessor: 't',
      readOnly: false
    },
    {
      id: 'n',
      label: 'N',
      isVisible: true,
      accessor: 'n',
      readOnly: false
    },
    {
      id: 'm',
      label: 'M',
      isVisible: true,
      accessor: 'm',
      readOnly: false
    },
    {
      id: 'grade',
      label: 'Grade',
      isVisible: true,
      accessor: 'grade',
      readOnly: false
    },
    {
      id: 'stageGroup',
      label: 'Stage Group',
      isVisible: true,
      accessor: 'stageGroup',
      readOnly: false
    }
  ]
} as Template;

// This template list is just for SB
export const storyTemplates = [
  defaultTemplate,
  {
    name: 'liver',
    columns: [
      {
        id: 'id',
        label: 'ID',
        isVisible: false,
        accessor: 'id',
        readOnly: true
      },
      {
        id: 'timing',
        label: 'Timing',
        isVisible: true,
        accessor: 'timing',
        readOnly: true
      },
      {
        id: 't',
        label: 'T',
        isVisible: true,
        accessor: 't',
        readOnly: false
      },
      {
        id: 'n',
        label: 'N',
        isVisible: true,
        accessor: 'n',
        readOnly: false
      },
      {
        id: 'm',
        label: 'M',
        isVisible: true,
        accessor: 'm',
        readOnly: false
      },
      {
        id: 'grade',
        label: 'Grade',
        isVisible: true,
        accessor: 'grade',
        readOnly: false
      },
      {
        id: 'stageGroup',
        label: 'Stage Group',
        isVisible: true,
        accessor: 'stageGroup',
        readOnly: false
      }
    ]
  },
  {
    name: 'breast',
    columns: [
      {
        id: 'id',
        label: 'ID',
        isVisible: false,
        accessor: 'id',
        readOnly: true
      },
      {
        id: 'timing',
        label: 'Timing',
        isVisible: true,
        accessor: 'timing',
        readOnly: true
      },
      {
        id: 't',
        label: 'T',
        isVisible: true,
        accessor: 't',
        readOnly: false
      },
      {
        id: 'n',
        label: 'N',
        isVisible: true,
        accessor: 'n',
        readOnly: false
      },
      {
        id: 'm',
        label: 'M',
        isVisible: true,
        accessor: 'm',
        readOnly: false
      },
      {
        id: 'grade',
        label: 'Grade',
        isVisible: true,
        accessor: 'grade',
        readOnly: false
      },
      {
        id: 'erInterpretation',
        label: 'ER Interpretation',
        isVisible: true,
        accessor: 'erInterpretation',
        readOnly: false
      },
      {
        id: 'prInterpretation',
        label: 'PR Interpretation',
        isVisible: true,
        accessor: 'prInterpretation',
        readOnly: false
      },
      {
        id: 'her2',
        label: 'HER2',
        isVisible: true,
        accessor: 'her2',
        readOnly: false
      },
      {
        id: 'stageGroup',
        label: 'Stage Group',
        isVisible: true,
        accessor: 'stageGroup',
        readOnly: false
      }
    ]
  },
  {
    name: 'brain',
    columns: [
      {
        id: 'id',
        label: 'ID',
        isVisible: false,
        accessor: 'id',
        readOnly: true
      },
      {
        id: 'timing',
        label: 'Timing',
        isVisible: true,
        accessor: 'timing',
        readOnly: true
      },
      {
        id: 'grade',
        label: 'Grade',
        isVisible: true,
        accessor: 'grade',
        readOnly: false
      }
    ]
  },
  {
    name: 'hematologic',
    columns: nonTNMColumns
  },
  {
    name: 'lymph',
    columns: nonTNMColumns
  }
] as Template[];
